export default "__VITE_ASSET__BekQ4OeH__"